import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, certissueActions, alertActions } from '../../../../store/actions'

import CertIssueList from './CertIssueList'
import Calendar from '../../../../module/component-box/Calendar'
import queryString from 'query-string'
import Pagination from '../../../../module/pagination-box'
import history from '../../../../route/history'
import * as Common from '../../../../assets/js/common.js'
import Loading from '../../../../module/loading/Loading'

const CertIssue = (props) => {
  const [state, setState] = useState({
    tabStatus: '',
    srhIssueType: '',
    srhPrchsNm: '',
    searchWord: '',
    srhFrom: '',
    srhTo: '',
    srhOrder: '',
    srhBy: '',
    pageIdx: 0,
  })

  const [countInfo, setCountInfo] = useState({
    countALL: 0,
    count02: 0,
    count03: 0,
    count04: 0,
  })

  const [pagingInfo, setPagingInfo] = useState({})
  const [tabId, setTabId] = useState('')
  const [init, setInit] = useState('N')

  const issuInstCd = [
    { name: 'KTNet', value: 'KTNet' },
    { title: 'EKTNET', value: 'EKTNET' },
    { title: '한국무역정보통신', value: '한국무역정보통신' },
  ]
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    console.log('state', state)
  }, [state])

  useEffect(() => {
    props.common({ mainCd: ['CRT_STS_CD', 'CRT_DV', 'ISSU_INST_CD'] })

    const query = queryString.parse(history.location.search)
    // console.log('query = ', query)

    if (Object.keys(query).length > 0) {
      props.settingHistory(query)
      setState(query)
    } else {
      props.changeSearchInfo(null) // 이전 검색 초기화
      searchList()
    }
    /*
    return () => {
    }
    */
  }, [])

  useEffect(() => {
    // count갯수 설정...
    setCountInfo({
      ...countInfo,
      countALL: props.countInfo?.ALL,
      count02: props.countInfo?.['02'],
      count03: props.countInfo?.['03'],
      count04: props.countInfo?.['04'],
    })
  }, [props.countInfo])

  useEffect(() => {
    if (props.commoncode.length < 1) return
  }, [props.commoncode])

  useEffect(() => {
    setPagingInfo({
      totalRecords: props.CertIssueList?.totalElements ? props.CertIssueList?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.CertIssueList?.pageable?.pageNumber,
      pagesToShow: 10,
    })

    //setPrintList(props.CertIssueList?.content);
    if (props.CertIssueList) {
      setLoading(false)
    }
  }, [props.CertIssueList])

  // useEffect(() => {
  //   if (!props.history) return
  //   const idx = props.history?.pageIdx ? props.history?.pageIdx : 0
  //   searchList(null, idx)
  // }, [props.history])

  const searchTabInfo = [
    {
      title: '전체',
      id: '',
      count: countInfo.countALL,
    },
    {
      title: '전송완료',
      id: '02',

      count: countInfo?.count02,
    },
    {
      title: '발급완료',
      id: '03',
      count: countInfo?.count03,
    },
    {
      title: '오류통보',
      id: '04',
      count: countInfo?.count04,
    },
  ]

  const onSelected = (e, name, value) => {
    if (name === 'tabStatus') {
      setTabId(value)
    }

    // console.log('onSelected')
    setState({
      ...state,
      [name]: value,
    })
  }

  const searchList = (index = 0) => {
    if (document.getElementById('srhFrom').value > document.getElementById('srhTo').value) {
      return props.error({ message: '기간설정을 다시 입력해주세요.' })
    } else {
      let searchInfo = {}
      const { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord } = state

      tabStatus?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      searchWord?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      srhPrchsNm?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      srhIssueType?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      srhFrom?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      srhTo?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      srhOrder?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      srhBy?.length > 0 && (searchInfo = { tabStatus, srhIssueType, srhPrchsNm, srhFrom, srhTo, srhOrder, srhBy, searchWord })
      index > 0 && (searchInfo.pageIdx = index)

      // console.log('searchList')
      setState({
        ...state,
        pageIdx: typeof index === 'object' ? 0 : index,
      })

      let paramStr = queryString.stringify(searchInfo)
      paramStr.length > 0 && (paramStr = '?' + paramStr)
      history.push('/service/certissue' + paramStr)

      setLoading(true)
      props.readCertIssueList(searchInfo)
      setInit('Y')
    }
  }

  const onCertIssueDetail = (issue) => {
    //props.selectCertIssueInfo(issue) // 선택한 대상의 정보 셋팅
    history.push({ pathname: '/service/certissue/detail/' + issue.crtSeq, state: state })
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchList()
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    setState({
      ...state,
      [name]: value,
    })
  }

  const selectDay = (type) => {
    const d = new Date()
    const year = d.getFullYear() // 년
    const month = d.getMonth() // 월
    const day = d.getDate() // 일

    if (Common.getDeviceType() === 'MobileApp' && window.M.navigator.device('ios')) {
      let y, m, d, h, mm, s
      let today = new Date()
      y = today.getFullYear()
      m = today.getMonth()
      d = today.getDate()
      h = 0
      mm = 0
      s = 0
      if (type === 'W1') {
        // 1주일
        setState({
          ...state,
          srhFrom: moment(new Date(Date.UTC(y, m, d - 7, h, mm, s))).format('Y-MM-DD'),
          srhTo: moment(new Date(Date.UTC(y, m, d, h, mm, s))).format('Y-MM-DD'),
        })
      } else if (type === 'M1') {
        // 1개월
        setState({
          ...state,
          srhFrom: moment(new Date(Date.UTC(y, m - 1, d, h, mm, s))).format('Y-MM-DD'),
          srhTo: moment(new Date(Date.UTC(y, m, d, h, mm, s))).format('Y-MM-DD'),
        })
      } else if (type === 'M3') {
        // 3개월
        setState({
          ...state,
          srhFrom: moment(new Date(Date.UTC(y, m - 3, d, h, mm, s))).format('Y-MM-DD'),
          srhTo: moment(new Date(Date.UTC(y, m, d, h, mm, s))).format('Y-MM-DD'),
        })
      } else if (type === 'M6') {
        // 6개월
        setState({
          ...state,
          srhFrom: moment(new Date(Date.UTC(y, m - 6, d, h, mm, s))).format('Y-MM-DD'),
          srhTo: moment(new Date(Date.UTC(y, m, d, h, mm, s))).format('Y-MM-DD'),
        })
      } else if (type === 'Y1') {
        // 1년
        setState({
          ...state,
          srhFrom: moment(new Date(Date.UTC(y - 1, m, d, h, mm, s))).format('Y-MM-DD'),
          srhTo: moment(new Date(Date.UTC(y, m, d, h, mm, s))).format('Y-MM-DD'),
        })
      } else {
        setState({
          ...state,
          srhFrom: null,
          srhTo: null,
        })
      }
    } else {
      if (type === 'W1') {
        // 1주일
        setState({
          ...state,
          srhFrom: moment(new Date(year, month, day - 7).toLocaleDateString()).format('Y-MM-DD'),
          srhTo: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
        })
      } else if (type === 'M1') {
        // 1개월
        setState({
          ...state,
          srhFrom: moment(new Date(year, month - 1, day).toLocaleDateString()).format('Y-MM-DD'),
          srhTo: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
        })
      } else if (type === 'M3') {
        // 3개월
        setState({
          ...state,
          srhFrom: moment(new Date(year, month - 3, day).toLocaleDateString()).format('Y-MM-DD'),
          srhTo: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
        })
      } else if (type === 'M6') {
        // 6개월
        setState({
          ...state,
          srhFrom: moment(new Date(year, month - 6, day).toLocaleDateString()).format('Y-MM-DD'),
          srhTo: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
        })
      } else if (type === 'Y1') {
        // 1년
        setState({
          ...state,
          srhFrom: moment(new Date(year - 1, month, day).toLocaleDateString()).format('Y-MM-DD'),
          srhTo: moment(new Date(year, month, day).toLocaleDateString()).format('Y-MM-DD'),
        })
      } else {
        setState({
          ...state,
          srhFrom: null,
          srhTo: null,
        })
      }
    }
  }

  useEffect(() => {
    if (init === 'Y') {
      // console.log("init === 'Y'11111111111111111")
      searchList()
    }
  }, [state.srhPrchsNm])

  useEffect(() => {
    if (init === 'Y') {
      // console.log("init === 'Y'222222222222222222")
      searchList()
    }
  }, [state.srhIssueType])

  // useEffect(() => {
  //   if (init === 'Y') {
  //     searchList()
  //   }
  // }, [state.searchWord])

  useEffect(() => {
    if (init === 'Y') {
      // console.log("init === 'Y'33333333333333333")
      searchList()
    }
  }, [state.tabStatus])

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }
  return (
    <>
      {/* contents */}
      {loading ? <Loading /> : null}
      <div id="contents">
        <div className="content-header">
          <a href="#" onClick={prePage} className="page-prev">
            뒤로이동
          </a>{' '}
          {/* mobile */}
          <h2>증명서 신청 현황</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <em>신청 현황</em>
          </div>
        </div>

        <div className="search-box">
          <div className="row">
            <span className="tit">기간</span>
            <span className="datepicker">
              <Calendar
                onSelect={(value) => onSelected(null, 'srhFrom', value ? moment(value).format('Y-MM-DD') : '')}
                default={state.srhFrom === null ? null : state.srhFrom?.toString()}
                title="처음날짜(발급일)"
                id="srhFrom"
              />
              <span className="split">~</span>
              <Calendar
                onSelect={(value) => onSelected(null, 'srhTo', value ? moment(value).format('Y-MM-DD') : '')}
                default={state.srhTo === null ? null : state.srhTo?.toString()}
                title="마지막날짜(발급일)"
                id="srhTo"
              />
            </span>
            <span className="form-date">
              <button type="button" className="btn-primary" onClick={() => selectDay('W1')}>
                1주일
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M1')}>
                1개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M3')}>
                3개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M6')}>
                6개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('Y1')}>
                1년간
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('99')}>
                초기화
              </button>
            </span>
          </div>
          <div className="row">
            <span className="tit">발급처</span>
            <select
              className="form-category"
              title="발급처"
              name="srhPrchsNm"
              id="srhPrchsNm"
              value={state.srhPrchsNm || ''}
              onChange={handleChange}
            >
              <option value="" key={''}>
                전체
              </option>
              {issuInstCd.map((type, index) => {
                return (
                  <option key={'cd' + index} value={type.name}>
                    {type.value}
                  </option>
                )
              })}
            </select>
            <span className="tit">신청방법</span>
            <select
              className="form-category"
              title="신청방법"
              name="srhIssueType"
              id="srhIssueType"
              value={state.srhIssueType || ''}
              onChange={handleChange}
            >
              <option value="" defaultValue={props.defaultValue === '전체'}>
                전체
              </option>
              <option value="1" defaultValue={props.defaultValue === '일반'}>
                일반
              </option>
              <option value="2" defaultValue={props.defaultValue === '꾸러미'}>
                꾸러미
              </option>
            </select>
            <span className="tit">검색어</span>
            <div className="inquiry-group">
              <input
                type="text"
                placeholder="증명서명 또는 발급번호를 입력하세요."
                className="form-keyword"
                id="searchWord"
                name="searchWord"
                value={state.searchWord || ''}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
              />
              <button className="btn-search" onClick={searchList}>
                검색
              </button>
            </div>
          </div>
        </div>

        <div className="tbl-wrap mt20">
          <table className="tbl-list">
            <caption>전체, 전송완료, 발급완료, 오류통보 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '25%' }} />
              <col style={{ width: '25%' }} />
              <col style={{ width: '25%' }} />
              <col style={{ width: '25%' }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">전체</th>
                <th scope="col">전송완료</th>
                <th scope="col">발급완료</th>
                <th scope="col">오류통보</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {searchTabInfo.map((item, index) => (
                  <td key={index}>
                    <a
                      href="./"
                      onClick={(e) => {
                        e.preventDefault()
                        //console.log('state.tabStatus = ', state.tabStatus);
                        onSelected(e, 'tabStatus', item.id)
                      }}
                      title={item.title}
                    >
                      {state.tabStatus === item.id ? (
                        <strong className="text-blue"> {item.count}</strong>
                      ) : (
                        <strong className="text-red"> {item.count}</strong>
                      )}
                    </a>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <CertIssueList
          data={props.CertIssueList?.content}
          commoncode={props.commoncode}
          onCertIssueDetail={onCertIssueDetail}
          reload={props.readCertIssueList}
        />

        <div className="list-footer">
          <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(param - 1)} />
        </div>
        <div className="guide-box gray mt40">
          <dl className="dlist1">
            <dt>처리상태 안내</dt>
            <dd>
              <span className="text-blue">전송완료</span> : 발급기관에 신청서 전송완료 중입니다.
            </dd>
            <dd>
              <span className="text-black">발급완료</span> : 증명서 신청이 완료되어 발급이 가능합니다.
            </dd>
            <dd>
              <span className="text-red">오류통보</span> : 구비서류 미제출 시 자동으로 취소됩니다.
            </dd>
          </dl>
        </div>
        <div className="guide-box gray mt20">
          <dl className="dlist1">
            <dt>수수료 취소 안내</dt>
            <dd>처리상태가 ‘접수’인 경우만 취소(환불) 가능이 가능합니다.</dd>
            <dd>
              결제 수단별 취소 기간 제한이 있으니 참고바랍니다.
              <br /> - 신용카드 / 무통장입금 : 결제 후 28일 이내 건에 대해서만 취소 가능
              <br /> - 휴대폰 : 결제 해당 월에 한하여 취소 가능
            </dd>
          </dl>
        </div>
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    CertIssueList: state.certissue?.CertIssueList?.list,
    countInfo: state.certissue?.CertIssueList?.count,
    commoncode: state.commoncode?.co,
    history: state.certissue?.history,
  }
}

const actionCreators = {
  changeSearchInfo: certissueActions.changeSearchInfo,
  readCertIssueList: certissueActions.readCertIssueList,
  common: commonActions.getCommonCode,
  settingHistory: certissueActions.settingHistory,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertIssue)
